export class RequestParam{
    constructor(
        public name:string,
        public value:string,
        public description:string,
        public isHidden: boolean = false,
        public subprod: number = 0,
    ){}
}